export default __webpack_public_path__ + "static/media/NOW-11616_R.84d82926.jpg";